import { TotalFileDownloadSupplier } from './TotalFileDownloadSupplier';
import { TotalFileDownloadDTO } from '../dtos';

export interface TotalFileDownloadProps {
  lastRecalculated: string;
  recalculationRequested: boolean;
  suppliers?: TotalFileDownloadSupplier[];
}

export class TotalFileDownload {
  lastRecalculated: string;
  recalculationRequested: boolean;
  suppliers?: TotalFileDownloadSupplier[];

  constructor({ lastRecalculated, recalculationRequested, suppliers }: TotalFileDownloadProps) {
    this.lastRecalculated = lastRecalculated;
    this.recalculationRequested = recalculationRequested;
    this.suppliers = suppliers;
  }

  static fromDto(dto: TotalFileDownloadDTO): TotalFileDownload {
    return new TotalFileDownload({
      lastRecalculated: dto.lastRecalculated,
      recalculationRequested: dto.recalulationRequested,
      suppliers: dto.suppliers?.map((supplier) => TotalFileDownloadSupplier.fromDto(supplier)),
    });
  }
}
